import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'lib-icon',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--icon]': 'iconUrl()',
  },
  styles: `
    :host {
      display: inline-block;
      background-color: currentColor;
      mask-image: var(--icon);
      mask-repeat: no-repeat;
      mask-position: center;
      mask-size: contain;
    }
  `,
})
export class Icon {
  readonly icon = input.required<string>();
  protected readonly iconUrl = computed(() => `url('icons/${this.icon()}.svg')`);
}
